import {
  Button,
  Checkbox,
  Menu,
  MenuItem,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableFooter,
  TableHead,
  TablePagination,
  TableRow,
} from '@material-ui/core';
import { MoreHoriz, AddCircle, RemoveCircle, DragIndicator } from '@material-ui/icons';
import CreateIcon from '@material-ui/icons/Create';
import DeleteForeverIcon from '@material-ui/icons/DeleteForever';
import VisibilityIcon from '@mui/icons-material/Visibility';
import React from 'react';
import { FEEDBACK_EDIT } from '../../../../constants/FeedbackConst';
import {
  RBAC_PERMISSION_LEVEL_FULL_ACCESS,
  RBAC_TYPE_CMS_FEEDBACK,
} from '../../../../constants/RoleConsts';
import TablePaginationActions from '../../../../shared/table-pagination/TablePaginationActions';
import { DragDropContext, Droppable, Draggable } from 'react-beautiful-dnd';
import { handleOnDragEnd } from '../../../../shared/custom-dragdrop/dragDrop';
import BulkActionCheckBox from '../../../../shared/MultiActionPopUp/BulkActionCheckBox';
import { PARTIAL_CHECKBOX_GREEN } from '../../../../utils/formUtils';

const FeedBackTable = (props) => {
  const {
    list,
    page,
    rowsPerPage,
    handleCellMenuClick,
    selectedValue,
    handleClose,
    onClickRowViewDetails,
    onViewDetails,
    onClickDelete,
    handleChangePage,
    handleChangeRowsPerPage,
    onOpenDrawer,
    permissions,
    onActiveDeactive,
    setVisible,
    setFeedbackList,
    handleSelectAll,
    isAllSelected,
    setIsAllSelected,
    handleCheckboxChange,
    selectedFeedbackLength,
    dragDisabled,
  } = props;

  return (
    <TableContainer>
      <Table className='list-table' aria-label='simple table'>
        <TableHead>
          <TableRow>
            <TableCell className={`w-5 ${dragDisabled ? '' : 'ps-5'}`}>
              <BulkActionCheckBox
                onChange={handleSelectAll}
                checked={isAllSelected || false}
                selectedLength={selectedFeedbackLength}
                totalLength={list?.length}
                inputProps={{
                  'aria-label': 'select all Feedbacks',
                }}
                className={PARTIAL_CHECKBOX_GREEN}
              />
            </TableCell>

            <TableCell className='w-30'>Name</TableCell>
            <TableCell className='w-25'>Destination</TableCell>
            <TableCell className='w-25' align='left'>
              Duration after experience
            </TableCell>
            <TableCell className='w-20 text-center'>Status</TableCell>
            <TableCell align='right'></TableCell>
          </TableRow>
        </TableHead>

        <DragDropContext
          onDragEnd={(event) =>
            handleOnDragEnd(event, setVisible, list, setFeedbackList, false, page, rowsPerPage)
          }
          isDropDisabled={dragDisabled}
        >
          <Droppable droppableId='restaurants' isDropDisabled={dragDisabled}>
            {(provided) => (
              <TableBody {...provided.droppableProps} ref={provided.innerRef}>
                {(rowsPerPage > 0
                  ? list.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                  : list
                ).map((feedback, key) => (
                  <Draggable
                    key={feedback.id}
                    draggableId={feedback.id}
                    index={key}
                    isDragDisabled={dragDisabled}
                  >
                    {(provided) => (
                      <TableRow
                        key={key}
                        className='border-white pointer'
                        onClick={(e) => {
                          onClickRowViewDetails(feedback, e);
                        }}
                        ref={provided.innerRef}
                        {...provided.draggableProps}
                        {...provided.dragHandleProps}
                      >
                        <TableCell className='w-12'>
                          {!dragDisabled && (
                            <span style={{ marginRight: 2 }}>
                              <DragIndicator className='res-menu-accordion-drag' />
                            </span>
                          )}
                          <Checkbox
                            onChange={(event) => handleCheckboxChange(feedback?.id)}
                            checked={feedback?.isChecked || false}
                            inputProps={{
                              'aria-label': `select notification ${feedback?.id}`,
                            }}
                          />
                        </TableCell>
                        <TableCell className='w-30'>{feedback?.pageTitle}</TableCell>
                        <TableCell className='w-25'>{feedback?.destination}</TableCell>
                        <TableCell className='w-25' align='left'>
                          {feedback?.duration} mins
                        </TableCell>
                        <TableCell className='w-20 text-center'>
                          <div className='d-flex justify-content-center'>
                            <div
                              className={`pill d-flex justify-content-center align-items-center ${
                                feedback?.isActive
                                  ? 'pill-active'
                                  : 'pill-inactive theme-dark-green'
                              }`}
                            >
                              <span className='ms-1'>
                                {feedback?.isActive ? 'Active' : 'Inactive'}
                              </span>
                            </div>
                          </div>
                        </TableCell>
                        <TableCell align='right'>
                          {permissions[RBAC_TYPE_CMS_FEEDBACK] ===
                            RBAC_PERMISSION_LEVEL_FULL_ACCESS && (
                            <Button
                              aria-controls='simple-menu'
                              aria-haspopup='true'
                              onClick={(e) => {
                                handleCellMenuClick(e, feedback);
                              }}
                              className='showpopupInner'
                            >
                              <MoreHoriz className='showpopupInner' />
                            </Button>
                          )}
                          {selectedValue.id === feedback.id && (
                            <Menu
                              id={key}
                              anchorEl={selectedValue?.anchorEl}
                              disableRestoreFocus
                              MenuListProps={{ autoFocusItem: false }}
                              keepMounted
                              open={Boolean(selectedValue.anchorEl)}
                              onClose={handleClose}
                              className='shadow'
                            >
                              <MenuItem
                                className='pe-4'
                                onClick={(e) => onActiveDeactive(e, feedback.isActive)}
                              >
                                {feedback.isActive ? (
                                  <>
                                    <RemoveCircle className='me-2 action-menu-icon' />
                                    Deactivate
                                  </>
                                ) : (
                                  <>
                                    <AddCircle className='me-2 action-menu-icon' />
                                    Activate
                                  </>
                                )}
                              </MenuItem>
                              <MenuItem
                                className='pe-4'
                                onClick={(e) => onOpenDrawer(e, FEEDBACK_EDIT)}
                              >
                                <CreateIcon className='me-2 action-menu-icon' />
                                Edit
                              </MenuItem>
                              <MenuItem
                                className='pe-4'
                                onClick={(e) => onViewDetails(feedback, e)}
                              >
                                <VisibilityIcon className='me-2 action-menu-icon' />
                                View
                              </MenuItem>
                              <MenuItem className='pe-4' onClick={(e) => onClickDelete(e)}>
                                <DeleteForeverIcon className='me-2 action-menu-icon' />
                                Delete
                              </MenuItem>
                            </Menu>
                          )}
                        </TableCell>
                      </TableRow>
                    )}
                  </Draggable>
                ))}
                {provided.placeholder}
              </TableBody>
            )}
          </Droppable>
        </DragDropContext>
        <TableFooter>
          <TableRow className='paginator'>
            <TablePagination
              rowsPerPageOptions={[5, 10, 25, { label: 'All', value: -1 }]}
              count={list.length}
              rowsPerPage={rowsPerPage}
              page={page}
              SelectProps={{
                inputProps: { 'aria-label': 'rows per page' },
                native: true,
              }}
              onPageChange={handleChangePage}
              onRowsPerPageChange={handleChangeRowsPerPage}
              ActionsComponent={TablePaginationActions}
            />
          </TableRow>
        </TableFooter>
      </Table>
    </TableContainer>
  );
};

export default FeedBackTable;
